import type {
  GameForfeit,
  GameStatusInfo,
  GameStatusKey,
} from '@sportninja/common/features/game/gameListView/gameStatus'

import { gameViewsLabel } from './i18n'

const KEY_LABEL: Record<GameStatusKey, string> = {
  scheduled: 'gameStatusScheduled',
  inProgress: 'gameStatusInProgress',
  final: 'gameStatusFinal',
  delayed: 'gameStatusDelayed',
  postponed: 'gameStatusPostponed',
  suspended: 'gameStatusSuspended',
  cancelled: 'gameStatusCancelled',
}

const FORFEIT_LABEL: Record<GameForfeit, string> = {
  home: 'gameStatusForfeitHome',
  visiting: 'gameStatusForfeitVisiting',
  double: 'gameStatusForfeitDouble',
}

/**
 * The status as a reader sees it: "Final", "Final - Home Forfeit", "Postponed".
 *
 * The forfeit QUALIFIES the result rather than replacing it, and the separator
 * matches the List row's own ("FINAL - HOME FORFEIT") so the two views do not
 * describe the same game two ways.
 */
export const gameStatusLabel = (status: GameStatusInfo): string => {
  const base = gameViewsLabel(KEY_LABEL[status.key])
  if (status.forfeit === null) {
    return base
  }
  return `${base} - ${gameViewsLabel(FORFEIT_LABEL[status.forfeit])}`
}

/**
 * The same, with the rolled-back marker.
 *
 * Separate from `gameStatusLabel` because the two have different jobs: this is
 * what the grid SORTS, FILTERS and EXPORTS on — an admin searching "review" has
 * to find these rows — while the tag itself keeps the marker as its own visual
 * element rather than as more text.
 */
export const gameStatusFullLabel = (status: GameStatusInfo): string => {
  const label = gameStatusLabel(status)
  if (!status.inReview) {
    return label
  }
  return `${label} - ${gameViewsLabel('gameStatusInReview')}`
}
